module.exports = __webpack_public_path__ + "97bb21535e0ed10e28fec2de41eb3b79.svg";